<svelte:options
  customElement={{
    tag: "oc-action-signifier-v1",
    /*                       */
    extend: window.__components.extend(),
    props: {
      label: { type: "String", attribute: "label" },
      inverted: { type: "Boolean", attribute: "inverted" },
      variant: { type: "String", attribute: "variant" },
    },
  }}
/>

<script lang="ts">
  let { label = undefined, inverted = false, variant = "icon" } = $props();
</script>

<div class="action-signifier">
  {#if variant === "text"}
    <span class={`action-signifier__text ${inverted ? "action-signifier__text--inverted" : ""}`}>
      {label}
    </span>
    <div
      class={`action-signifier__text-icon  ${inverted ? "action-signifier__text-icon--inverted" : ""}`}
    >
      <oc-icon-v1 type="arrow-right" size={/*                      */ "50"}></oc-icon-v1>
    </div>
  {/if}

  {#if variant === "icon"}
    <div class={`action-signifier__icon ${inverted ? "action-signifier__icon--inverted" : ""}`}>
      <oc-icon-v1 type="arrow-right" size={/*                      */ "100"}></oc-icon-v1>
    </div>
  {/if}
</div>

<style lang="scss" global>
  @use "@otto-ec/design-tokens/component" as tokens;
  .action-signifier {
    color: tokens.$oc-component-action-signifier-text-text-color;
    display: flex;
    align-items: center;
    gap: tokens.$oc-component-action-signifier-text-gap-x;

    /*                                       */
    &__text {
      font: tokens.$oc-component-action-signifier-text-font;

      &--inverted {
        color: tokens.$oc-component-action-signifier-inverted-text-color;
        text-decoration: underline;
      }
    }

    &__text-icon {
      color: tokens.$oc-component-action-signifier-text-text-color;

      &--inverted {
        color: tokens.$oc-component-action-signifier-inverted-icon-color;
      }
    }

    /*                                */
    &__icon {
      color: tokens.$oc-component-action-signifier-icon-icon-color;

      &--inverted {
        color: tokens.$oc-component-action-signifier-inverted-icon-color;
      }
    }
  }
</style>
